import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { setTrackingId } from "client/Misc/utils";
import { prepareHubItemTitle } from "./AnnouncementActivity";
import { EventNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type EventActivityProps = {
	data: EventNotificationDataViewModel;
};

export const EventActivity = (props: EventActivityProps): ReactElement => {
	const { data } = props;

	const title: string = prepareHubItemTitle(data.title);

	return (
		<>
			<span {...setTrackingId("title")}>
				<FormattedText
					text={localize("_NewEventTitle")}
					thingsToReplace={[
						{
							what: "{{Title}}",
							filler: (
								<Typography
									weight="bold"
									trackingId="event-title"
								>
									{title}
								</Typography>
							)
						}
					]}
				/>
			</span>.
		</>
	);
};

EventActivity.displayName = "EventActivity";